import { toast } from "react-toastify";
import { Mixpanel } from "../../../config/Mixpanel";
import constants from "../utilities/constants";
import { useSelector } from "react-redux";
import { selectChats } from "../../../redux/personaliseLessons/askCreatorSlice";

const ToggleButton = ({ isToggled, setIsToggled }) => {

    const { limit_reached } = useSelector(selectChats)

    const handleToggle = () => {
        if (limit_reached){
            setIsToggled(false)
            toast.warning('Upgrade to LearnTubeX to get audio support. ')
        }else {
            Mixpanel.track(constants.Mixpanel.LESSON_PAGE_VOICE_TOGGLE)
            setIsToggled(!isToggled);
        }
    };

    return (

        <label className="flex items-center">
            <input
                type="checkbox"
                className="hidden"
                checked={isToggled}
                onChange={handleToggle}
            />
            <div className={`w-[35px] h-[17px] border border-[#639DD4] rounded-full ${isToggled ? 'bg-[#639DD4]' : ''} cursor-pointer`}>
                <div className={`w-[13px] h-[13px] mt-[1.25px] ml-[1.5px] rounded-full transform ${isToggled ? 'translate-x-[20px] bg-[#255381]' : 'translate-x-0 bg-[#639DD4]'} transition-transform duration-300`}></div>
            </div>
            {/* <span className="ml-2 text-gray-700">{isToggled ? 'On' : 'Off'}</span> */}
        </label>
    )
}

export default ToggleButton